var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99976 3H14.9999H16.9998H16.9999V7.00002H18.9998H20.9996H20.9998V21H20.9996V21H6.99963V21V19V17.0001H2.99976V17V15.0001V5V3H4.99976ZM14.9999 7.00002V5H4.99976V15.0001H6.99963V9.00002V7.00002H8.99963H14.9999ZM8.99963 17.0001V19H18.9998V9.00002H8.99963V15.0001H8.99976V17.0001H8.99963Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyM);
export default __webpack_public_path__ + "static/media/copy-m.566181e23cc8b8afe4f42531d504e03e.svg";
export { ForwardRef as ReactComponent };